import { Environment } from '../app/core/models/environment.model';
import { commonEnvironment } from './environment.common';

export const environment: Environment = {
  ...commonEnvironment,
  production: false,
  apiUrl: 'https://api.menziltap.az'
};
